import styled from 'styled-components';

export const Container = styled.span`
  display: inline-block;
  filter: blur(4px);
  user-select: none;
  pointer-events: none;
`;
